import { CheckCircle, XCircle } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const ConsumerDifference = () => {
  const { ref, isVisible } = useScrollAnimation();

  const comparisons = [
    {
      category: "Traditional Agent",
      cons: ["6% commission fee", "Long listing process", "Limited to local buyers"],
      color: "text-red-400"
    },
    {
      category: "FSBO Alone",
      cons: ["Limited buyer reach", "No professional network", "Handle everything yourself"],
      color: "text-orange-400"
    },
    {
      category: "GoDyspo Consumer",
      pros: ["100% free marketing", "Access to investor network", "Fast closings possible", "Professional guidance"],
      color: "text-[#ffd700]"
    }
  ];

  return (
    <section ref={ref} className="py-20 px-4">
      <div className="container mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          <h2 className="text-4xl font-bold mb-4">What Makes This Different</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Compare your options and see why homeowners choose GoDyspo
          </p>
        </div>
        
        <div className={`grid md:grid-cols-3 gap-8 max-w-6xl mx-auto transition-all duration-700 delay-200 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          {comparisons.map((item, index) => (
            <div
              key={index}
              className={`bg-gray-800 border rounded-lg p-8 ${
                item.pros ? 'border-[#ffd700] shadow-lg shadow-[#ffd700]/10' : 'border-gray-700'
              }`}
            >
              <h3 className={`text-2xl font-semibold mb-6 ${item.color}`}>
                {item.category}
              </h3>
              <ul className="space-y-3">
                {item.cons?.map((con, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <XCircle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-400">{con}</span>
                  </li>
                ))}
                {item.pros?.map((pro, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <CheckCircle className="h-5 w-5 text-[#ffd700] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-300">{pro}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsumerDifference;
